import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function SimpleAccordion() {
  const classes = useStyles();

  return (

  <div className="my-5 py-5" id="FAQ" >
    <Container maxWidth="lg">
    <Grid style={{display:'block',marginLeft:'auto',marginRight:'auto'}}>
      <div className={classes.root} className="" >
                <h1 className="">
                    FAQ's
                    </h1>
                   
                <Accordion style={{backgroundColor:"#dcdcdc"}}  >
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{color:'black'}} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{backgroundColor: '#fdd53b',color: 'black'}}
                    >
                    <Typography className={classes.heading}><strong>How to buy Pcatv3 ?</strong></Typography>
                    </AccordionSummary>
                    <AccordionDetails >
                    <Typography>
                    <h6 className="text-left">Step 1 : Visit the pCATv3 exchange link below:</h6>
                    <p  className="text-left" ><a href="https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x41d7ca990138dddd70aef6a66cce6cf37b478428" style={{color:"#34A0FE"}} target="_blank">pCATv3/wBNB Pancakeswap</a></p>

                    <h6 className="text-left">Step 2 : Connect your wallet (Metamask / Trustwallet)</h6>
                    <p className="text-left">Make sure your wallet address on the Binance Smart Chain network</p>

                    <h6 className="text-left">Step 3 : Set 12% slippage</h6>
                    <p className="text-left">Setting your slippage less than 12% will not let the transaction throught.</p>


                    <h6 className="text-left">Step 4 : Use whole numbers</h6>
                    <p className="text-left">Values in decimals are automatically ignored by the exchange</p>



                    </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion style={{backgroundColor:"#dcdcdc"}} >
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{color:'black'}} />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    style={{backgroundColor: '#fdd53b',color: 'black'}}
                    >
                    <Typography className={classes.heading}><strong>How to add Pcatv3 to your wallet ?</strong></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography >
                    <h6 className="text-left">Add a new network to your connected wallet and input the following data:</h6>
                    <p className="text-left">Network : Binance Smartchain Mainet<br></br>
                    <span>Contract : 0x41D7CA990138DDDD70aEf6a66Cce6Cf37b478428</span><br></br>
                    <span>Token name : pCATv3.finance</span><br></br>
                    <span>Symbol : pCATv3</span><br></br>
                    <span>Decimals : 18</span><br></br>
                    </p>
                    </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion style={{backgroundColor:"#dcdcdc"}} >
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{color:'black'}} />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    style={{backgroundColor: '#fdd53b',color: 'black'}}>
                    <Typography className={classes.heading} ><strong>How to See/Claim Reward ?</strong></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Typography>
                    <h6 className="text-left">Step 1 : Go to</h6>
                    <p  className="text-left"><a href="https://www.pcatv3.finance" style={{color:"#34A0FE"}}>https://www.pcatv3.finance</a></p>

                    <h6 className="text-left">Step 2 : Select Claim Rewards</h6>
                    <p  className="text-left">Connect your Binance Smart Chain wallet, all updated stats will be shown in all indicators.</p>

                    <h6 className="text-left">Step 3 : Claim Rewards</h6>
                    <p  className="text-left">To collect rewards click on "Collect my BNB" button at the bottom of the dashboard.<br></br>
                    Note : BNB rewards are available to claim every Saturday.
                    </p>
                    </Typography>
                    </AccordionDetails>
                </Accordion>
                </div>
    </Grid>
    </Container>
  </div>
    
    
               

   
  );
}
